import React, { FC, useState } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'redux-scaffolding-ts';
import { ChecklistReportStore } from 'stores/checklist-reports/checklist-report-store';
import { useWindowSize } from 'utils/useWindowSize';
import ChecklistFilters, { ChecklistFiltersValue } from './checklist-filters';
import ChecklistMetricsCards from './checklist-metrics-cards';
import ChecklistMetricsCardsMobile from './checklist-metrics-cards-tw';
import ChecklistReportList from './checklist-report-list';
import ChecklistReportListMobile from './checklist-report-list-tw';
import LineSeparator from 'widgets/bussiness/line-separator';

interface ChecklistReportsLandingPageProps extends RouteComponentProps, WithTranslation {
  showTitle?: boolean;
  checklistReportStore?: ChecklistReportStore;
}

const ChecklistReportsLandingPage: FC<ChecklistReportsLandingPageProps> = props => {
  const { t } = props;
  const { width } = useWindowSize();
  const isMobile = width < 768;
  const [filters, setFilters] = useState<ChecklistFiltersValue>({});
  const [filtersKey, setFiltersKey] = useState(0);
  const showTitle = props.showTitle !== false;

  const handleReset = () => {
    setFiltersKey(key => key + 1);
    setFilters({});
  };

  const desktopFilters = (
    <div className="request-list__filters-wrapper event-list__new-filters-container checklist-reports__desktop-actions">
      <ChecklistFilters key={filtersKey} onFilterChange={setFilters} compact />
      <ChecklistMetricsCards compact />
    </div>
  );

  return (
    <>
      {showTitle && <h3>{t('CheckLists')}</h3>}
      {showTitle && <LineSeparator />}
      {isMobile ? (
        <>
          <ChecklistFilters key={filtersKey} onFilterChange={setFilters} />
          <ChecklistMetricsCardsMobile />
          <ChecklistReportListMobile {...props} filters={filters} onReset={handleReset} />
        </>
      ) : (
        <>
          <ChecklistReportList {...props} filters={filters} onReset={handleReset} hideHeaderActions mainActionsFilters={desktopFilters} />
        </>
      )}
    </>
  );
};

export default connect(['checklistReportStore', ChecklistReportStore])(withTranslation()(ChecklistReportsLandingPage));
